import { render, staticRenderFns } from "./LineLife.vue?vue&type=template&id=19f6d3c2&scoped=true"
import script from "./LineLife.vue?vue&type=script&lang=js"
export * from "./LineLife.vue?vue&type=script&lang=js"
import style0 from "./LineLife.vue?vue&type=style&index=0&id=19f6d3c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f6d3c2",
  null
  
)

export default component.exports